import React from 'react';
import SectionHeading from './SectionHeading';

const Summary = function({ lang, isDark, sections, professionalSummary }) {
  return (
    <section id="summary" className="mb-2" aria-labelledby="summary-heading">
      <div className="section-card">
        <SectionHeading id="summary-heading" isDark={isDark}>{sections.summary}</SectionHeading>
        <div className={`text-sm leading-loose whitespace-pre-line ${isDark ? 'text-slate-300' : 'text-slate-700'}`}>
          {professionalSummary}
        </div>
      </div>
    </section>
  );
}

export default React.memo(Summary);
